export const baseUrl = 'http://shopsafemarin-env.eba-vjj6mcnm.us-east-2.elasticbeanstalk.com/';